import { Fragment } from "react";
import logo from "../../images/logo/hrb-logo.png";
import FloatingSupport from "../components/FloatingSupport/FloatingSupport";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const Termsofservice = () => {
  const navigate = useNavigate();

  return (
    <Fragment>
      <div className="container-fluid p-0">
        <div className="row gx-0 justify-content-center">
          <div className="col-xl-12 col-sm-12 bg-white p-4">
            {/* Terms of service */}
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="logo-cotainer text-center mb-4">
                    <img style={{ maxWidth: "150px" }} src={logo} alt="logo" />
                  </div>
                  <div className="login-form term-basic-card">
                    <h2>Terms of service</h2>

                    <div style={{ whiteSpace: "pre-wrap", color: "black" }}>
                      <div>
                        Welcome to vegasdata.homes (the "Website"), a website
                        and/or service provided by Homebuilders Research, Inc.,
                        a Nevada corporation ("Company," "we," "us," or "our").
                      </div>
                      <div className="mt-3">
                        These Terms of Service ("Terms") govern your access to
                        and use of our Website and any information, construction
                        and/or housing industry data, analytics, and other
                        services obtained through the Website and/or purchased
                        from us (collectively, "Services" or the "Service").
                      </div>
                      <div className="mt-3">
                        <b>
                          PLEASE READ THESE TERMS CAREFULLY. BY ACCESSING OR
                          USING OUR SERVICE, YOU AGREE TO BE BOUND BY THESE
                          TERMS. IF YOU DO NOT AGREE TO THESE TERMS, YOU MAY NOT
                          ACCESS OR USE THE SERVICE.
                        </b>
                      </div>
                      <div className="mt-3">
                        <b>1. Acceptance of Terms</b>
                        <div className="mt-3">
                          By creating an account, accessing the Website, or
                          using or purchasing any Services, you represent that
                          you have read, understood, and agree to be bound by
                          these Terms. If you are using the Service on behalf of
                          an entity, you represent and warrant that you have the
                          authority to bind that entity to these Terms.
                        </div>
                      </div>
                      <div className="mt-3">
                        <b>2. Description of Services</b>
                        <div className="mt-3">
                          The Service provides customers with access to
                          construction and/or housing industry data, including,
                          but not limited to, information regarding permits,
                          closings, buyer traffic, sales, cancellations, pricing
                          data, etc., market trends, and analytics primarily for
                          Clark County, Nevada.
                        </div>
                      </div>
                      <div className="mt-3">
                        <b>3. User Accounts</b>
                        <div className="mt-3">
                          To access most features of the Service, you must
                          register for an account. You agree to:
                        </div>
                        <div>
                          <ul
                            style={{
                              listStyleType: "disc",
                              paddingLeft: "20px",
                              marginTop: "15px",
                              display: "block",
                            }}
                          >
                            <li
                              style={{ listStyleType: "disc", color: "black" }}
                            >
                              Provide accurate, current, and complete
                              information during the registration process.
                            </li>
                            <li
                              style={{ listStyleType: "disc", color: "black" }}
                            >
                              Maintain the security of your password and accept
                              all risks of unauthorized access to your account.
                            </li>
                            <li
                              style={{ listStyleType: "disc", color: "black" }}
                            >
                              Promptly notify us if you discover or otherwise
                              suspect any security breaches related to the
                              Service.
                            </li>
                          </ul>
                          <div className="mt-3">
                            You are responsible for all activities that occur
                            under your account.
                          </div>
                        </div>
                      </div>

                      <div className="mt-3">
                        <b>4. Fees and Payment</b>
                        <div className="mt-3">
                          Access to the Service requires payment of subscription
                          fees. You agree to pay all applicable fees as
                          described on the Website. All fees are non-refundable
                          except as required by law. We reserve the right to
                          change our prices at any time.
                        </div>
                      </div>
                      <div className="mt-3">
                        <b>5. License and Use Restrictions</b>
                        <div className="mt-3">
                          Subject to your compliance with these Terms, we grant
                          you a limited, non-exclusive, non-transferable,
                          non-sublicensable license to access and use the
                          Service for your internal business purposes.
                        </div>
                        <div className="mt-3">You agree not to:</div>
                        <div>
                          <ul
                            style={{
                              listStyleType: "disc",
                              paddingLeft: "20px",
                              marginTop: "15px",
                              display: "block",
                            }}
                          >
                            <li
                              style={{ listStyleType: "disc", color: "black" }}
                            >
                              Resell, sublicense, or otherwise make the Service
                              or its data available to any third party.
                            </li>
                            <li
                              style={{ listStyleType: "disc", color: "black" }}
                            >
                              Use the Service for any illegal purpose or in
                              violation of any local, state, national, or
                              international law.
                            </li>
                            <li
                              style={{ listStyleType: "disc", color: "black" }}
                            >
                              Scrape, reverse-engineer, decompile, or otherwise
                              attempt to derive the source code or underlying
                              data of the Service.
                            </li>
                            <li
                              style={{ listStyleType: "disc", color: "black" }}
                            >
                              Remove, alter, or obscure any proprietary notices
                              on any portion of the Service.
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="mt-3">
                        <b>
                          6.{" "}
                          <u>Disclaimer of Warranties and Assumption of Risk</u>
                        </b>
                        <div className="mt-3">
                          THE SERVICE AND THE DATA AND INFORMATION PROVIDED
                          THEREIN ARE PROVIDED ON AN "AS IS" AND "AS AVAILABLE"
                          BASIS, WITHOUT ANY WARRANTIES OF ANY KIND, EITHER
                          EXPRESS OR IMPLIED.
                        </div>
                        <div className="mt-3">
                          TO THE FULLEST EXTENT PERMITTED BY LAW, THE COMPANY
                          DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, IN
                          CONNECTION WITH THE SERVICE AND YOUR USE THEREOF,
                          INCLUDING, WITHOUT LIMITATION, THE IMPLIED WARRANTIES
                          OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
                          AND NON-INFRINGEMENT.
                        </div>
                        <div className="mt-3">
                          THE COMPANY MAKES NO WARRANTIES OR REPRESENTATIONS
                          ABOUT THE ACCURACY, COMPLETENESS, RELIABILITY, OR
                          TIMELINESS OF THE SERVICE'S CONTENT. DATA MAY BE
                          INCOMPLETE, INACCURATE, OR OUT OF DATE. YOU
                          ACKNOWLEDGE THAT YOU ARE USING THE SERVICE AND
                          INFORMATION CONTAINED IN CONNECTION THEREWITH AT YOUR
                          OWN RISK.
                        </div>
                        <div className="mt-3">
                          YOU AGREE THAT WE HAVE NOT MADE ANY REPRESENTATIONS OR
                          WARRANTIES TO YOU OTHER THAN AS SET FORTH HEREIN AND,
                          AS SUCH, YOU HAVE NOT RELIED ON ANYTHING NOT SET FORTH
                          HEREIN.
                        </div>
                        <div className="mt-3">
                          YOU UNDERSTAND, ACKNOWLEDGE AND AGREE THAT ASPECTS OF
                          THE INFORMATION PROVIDED TO YOU IN CONNECTION WITH THE
                          SERVICE ARE OBTAINED FROM THIRD PARTIES AND, AS SUCH,
                          WE ARE UNABLE TO VERIFY THE ACCURACY OF ALL OF THE
                          INFORMATION. WE MAKE NO GUARANTEE OF THE ACCURACY OF
                          THE INFORMATION AND YOU ASSUME ALL RISKS ASSOCIATED
                          WITH YOUR USE OF SUCH INFORMATION.
                        </div>
                        <div className="mt-3">
                          Notwithstanding the foregoing,{" "}
                          <u>
                            all information provided by our Service is accurate
                            to the best of our knowledge and no information
                            provided is knowingly inaccurate.
                          </u>
                        </div>
                      </div>
                      <div className="mt-3">
                        <b>7. Limitation of Liability and Exculpation</b>
                        <div className="mt-3">
                          YOU AGREE THAT, TO THE FULLEST EXTENT PERMITTED BY
                          APPLICABLE LAW, IN NO EVENT SHALL THE COMPANY, ITS
                          OFFICERS, DIRECTORS, EMPLOYEES, OR AGENTS, BE LIABLE
                          TO YOU FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
                          PUNITIVE, OR CONSEQUENTIAL DAMAGES WHATSOEVER
                          RESULTING FROM ANY: (I) ERRORS, MISTAKES, OR
                          INACCURACIES OF CONTENT OR DATA OBTAINED BY YOU IN
                          CONNECTION WITH THE SERVICES; (II) PERSONAL INJURY OR
                          PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER, RESULTING
                          FROM YOUR ACCESS TO AND USE OF OUR SERVICE; (III) ANY
                          UNAUTHORIZED ACCESS TO OR USE OF OUR SECURE SERVERS
                          AND/OR ANY AND ALL PERSONAL INFORMATION STORED
                          THEREIN; (IV) ANY INTERRUPTION OR CESSATION OF
                          TRANSMISSION TO OR FROM OUR SERVICE; (V) ANY BUGS,
                          VIRUSES, TROJAN HORSES, OR THE LIKE WHICH MAY BE
                          TRANSMITTED TO OR THROUGH OUR SERVICE BY ANY THIRD
                          PARTY.
                        </div>
                        <div className="mt-3">
                          THE FOREGOING LIMITATION OF LIABILITY SHALL APPLY TO
                          THE FULLEST EXTENT PERMITTED BY LAW AND INCLUDES
                          NEGLIGENCE OF ANY KIND.
                        </div>
                        <div className="mt-3">
                          IN NO EVENT SHALL THE COMPANY'S TOTAL AGGREGATE
                          LIABILITY TO YOU FOR ALL DAMAGES, LOSSES, AND CAUSES
                          OF ACTION (WHETHER IN CONTRACT, TORT (INCLUDING
                          NEGLIGENCE), OR OTHERWISE) EXCEED THE AMOUNT YOU HAVE
                          PAID TO THE COMPANY IN THE LAST SIX (6) MONTHS, OR, IF
                          GREATER, ONE HUNDRED DOLLARS ($100).
                        </div>
                        <div className="mt-3">
                          YOU AGREE THAT WE HAVE NOT MADE ANY REPRESENTATIONS OR
                          WARRANTIES TO YOU OTHER THAN AS SET FORTH HEREIN AND,
                          AS SUCH, YOU HAVE NOT RELIED ON ANYTHING NOT SET FORTH
                          HEREIN.
                        </div>
                        <div className="mt-3">
                          FURTHERMORE, YOU HEREBY KNOWINGLY AND VOLUNTARILY
                          RELEASE AND FOREVER DISCHARGE THE COMPANY, ITS
                          OFFICERS, DIRECTORS, EMPLOYEES, AGENTS, AND SUCCESSORS
                          FROM ANY AND ALL CLAIMS, DEMANDS, LIABILITIES,
                          ACTIONS, CAUSES OF ACTION, AND DAMAGES OF ANY KIND,
                          WHETHER KNOWN OR UNKNOWN, ARISING OUT OF OR IN ANY WAY
                          CONNECTED WITH YOUR USE OF THE SERVICE,{" "}
                          <b>CLAIMS FOR NEGLIGENCE.</b>
                        </div>
                        <div className="mt-3">
                          THE SOLE AND ABSOLUTE EXCEPTION TO THIS RELEASE IS FOR
                          CLAIMS DIRECTLY AND PROXIMATELY CAUSED BY THE
                          INTENTIONAL MISCONDUCT OF THE COMPANY.
                        </div>
                      </div>
                      <div className="mt-3">
                        <b>8. Indemnification</b>
                        <div className="mt-3">
                          You agree to defend, indemnify, and hold harmless the
                          Company, its affiliates, and their respective
                          officers, directors, employees, and agents from and
                          against any and all claims, damages, obligations,
                          losses, liabilities, costs, or debt, and expenses
                          (including but not limited to attorney's fees) arising
                          from: (i) your use of and access to the Service; (ii)
                          your violation of any term of these Terms; or (iii)
                          your violation of any third-party right, including
                          without limitation any copyright, property, or privacy
                          right.
                        </div>
                      </div>
                      <div className="mt-3">
                        <b>9. Governing Law and Exclusive Venue</b>
                        <div className="mt-3">
                          These Terms shall be governed by and construed in
                          accordance with the laws of the State of Nevada,
                          without regard to its conflict of law principles.
                        </div>
                        <div className="mt-3">
                          You agree that any legal action or proceeding arising
                          out of or relating to these Terms or the Service shall
                          be brought exclusively in the state or federal courts
                          located in <b>Clark County, Nevada.</b> You hereby
                          consent to the exclusive jurisdiction and venue of
                          such courts.
                        </div>
                      </div>
                      <div className="mt-3">
                        <b>10. Modifications to Terms</b>
                        <div className="mt-3">
                          We reserve the right, at our sole discretion, to
                          modify or replace these Terms at any time. If a
                          revision is material, we will provide at least 30
                          days' notice prior to any new terms taking effect.
                          What constitutes a material change will be determined
                          at our sole discretion.
                        </div>
                        <div className="mt-3">
                          No medication, amendment or waiver of any provision of
                          these Terms will be effective unless in writing and
                          signed by one of our authorized representatives.
                        </div>
                      </div>
                      <div className="mt-3">
                        <b>11. Complete Agreement</b>
                        <div className="mt-3">
                          These Terms shall constitute the entire agreement
                          between you and us concerning the Service. These Terms
                          supersede all prior and contemporaneous agreements,
                          proposals, representations, and understandings,
                          whether oral or written.
                        </div>
                      </div>
                      <div className="mt-3">
                        <b>12. Termination</b>
                        <div className="mt-3">
                          We may terminate or suspend your account and bar
                          access to the Service immediately, without prior
                          notice or liability, for your failure to pay amounts
                          due or other breach or violation of these Terms.
                        </div>
                      </div>
                      <div className="mt-3">
                        <b>13. Severability</b>
                        <div className="mt-3">
                          I agree that if any portion of these Terms are found
                          to be void or unenforceable, the remaining portions
                          shall remain in full force and effect.
                        </div>
                      </div>
                      <div className="mt-3">
                        <b>14. Contact Information</b>
                        <div className="mt-3">
                          If you have any questions about these Terms, please
                          contact us at info@homebuildersresearch.com.
                        </div>
                      </div>
                    </div>
                    <div className="text-center">
                      <Button
                        className="mt-3"
                        variant="primary"
                        onClick={() => navigate("/")}
                      >
                        Back To Login
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FloatingSupport inline={true} auth={true} />
    </Fragment>
  );
};

export default Termsofservice;
